import { FeedbackIcon } from "@/components/feedback";
import { Button, EmptyState, Surface, Text } from "@/components/ui";

interface ErrorPageProps {
  error: Error
}

const handleErrorReset = () => {
  localStorage.clear()
  window.location.replace("/")
}

export function ErrorPage({ error }: ErrorPageProps) {
  return (
    <Surface surface="page" className="flex min-h-screen flex-col items-center justify-center px-6">
      <EmptyState
        size="section"
        headingLevel={1}
        illustration={<FeedbackIcon variant="error" />}
        title="Opa! Algo deu errado"
        description="A gente já está de olho nisso. Tente recarregar a página."
        action={<Button onClick={handleErrorReset}>Recarregar página</Button>}
      />

      <details className="mt-2 w-full max-w-sm text-left">
        <summary className="cursor-pointer">
          <Text as="span" size="xs" weight="medium" tone="muted">Detalhes técnicos</Text>
        </summary>
        <Text size="xs" tone="muted" className="mt-2 break-words font-mono">
          {error.message}
        </Text>
      </details>
    </Surface>
  );
}
